module.exports = __webpack_public_path__ + "img/cashier05.24261092.png";